<p-card>
  <div class="card">
    <div class="col text-center">
      <h3>
        {{ "GENERAL.LOADING_TEXT" | translate }}
      </h3>
    </div>
    <p-progressBar
      mode="indeterminate"
      [style]="{ height: '6px' }"
    ></p-progressBar>
    <div class="grid formgrid">
      <div class="field col-12 pr-md-6 pr-0">
        <!-- <h5>Card</h5> -->
        <div class="custom-skeleton p-4">
          <div class="flex mb-3">
            <p-skeleton
              shape="circle"
              size="4rem"
              styleClass="mr-2"
            ></p-skeleton>
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton height=".5rem"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="150px"></p-skeleton>
        </div>

        <!--        <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>-->
      </div>
    </div>

    <div class="card">
      <div class="field col-12">
        <!-- <h5>List</h5> -->
        <div class="custom-skeleton p-4">
          <ul class="m-0 p-0">
            <!-- <li class="p-mb-3"> -->
            <div class="flex m-1">
              <p-skeleton
                shape="circle"
                size="4rem"
                styleClass="mr-2"
              ></p-skeleton>
              <div style="flex: 1">
                <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="75%"></p-skeleton>
              </div>
            </div>
            <!-- </li> -->
            <!-- <li class="p-mb-3"> -->
            <div class="flex m-1">
              <p-skeleton
                shape="circle"
                size="4rem"
                styleClass="mr-2"
              ></p-skeleton>
              <div style="flex: 1">
                <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="75%"></p-skeleton>
              </div>
            </div>
            <!-- </li> -->
            <!-- <li class="mb-3"> -->
            <div class="flex m-1">
              <p-skeleton
                shape="circle"
                size="4rem"
                styleClass="mr-2"
              ></p-skeleton>
              <div style="flex: 1">
                <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="75%"></p-skeleton>
              </div>
            </div>
            <!-- </li> -->
            <!-- <li> -->
            <div class="flex m-1">
              <p-skeleton
                shape="circle"
                size="4rem"
                styleClass="mr-2"
              ></p-skeleton>
              <div style="flex: 1">
                <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="75%"></p-skeleton>
              </div>
            </div>
            <!-- </li> -->
          </ul>
        </div>
      </div>
    </div>

    <!-- <h5>DataTable</h5> -->
    <p-table [value]="products">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>
            <p-skeleton></p-skeleton>
          </td>
          <td>
            <p-skeleton></p-skeleton>
          </td>
          <td>
            <p-skeleton></p-skeleton>
          </td>
          <td>
            <p-skeleton></p-skeleton>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>
